import { BareProperty, Property } from '../../shared/types/property';
import { User } from '../../shared/types/user';
import { forceIdToString } from './utils';

export function cleanUsername(username: string) {
  return username.toLowerCase().trim();
}

export function getUserProperties<T extends Property | BareProperty>(
  user: User,
  allProperties: T[]
): T[] {
  const { role } = user;

  switch (role.level) {
    case 'property':
      const safeAccess = [...role.access].map(forceIdToString);
      return allProperties.filter(p => safeAccess.includes(forceIdToString(p._id)));
    case 'brand':
      return allProperties;
  }
}
